import { render, staticRenderFns } from "./AllInvestmentsReceivablesResellModal.vue?vue&type=template&id=7007bd0b&scoped=true&"
import script from "./AllInvestmentsReceivablesResellModal.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesResellModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007bd0b",
  null
  
)

export default component.exports